import script from "./ContactValidate.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactValidate.vue?vue&type=script&setup=true&lang=js"

import "./ContactValidate.vue?vue&type=style&index=0&id=06944a9a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06944a9a"]])

export default __exports__